import { FunctionComponent } from "react"

import { useRedirectModalHook } from "@/hooks/redirectModal"
import { ChildrenProps } from "@/types/props"

// Show a modal when the agent is online and has an active contact
// Agent can only navigate to the call panel route to turn itself offline
const ForbidOnlineAgentRoute: FunctionComponent<ChildrenProps> = ({
  children,
}) => {
  useRedirectModalHook()

  return <>{children}</>
}

export default ForbidOnlineAgentRoute
